import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import dayjs from 'dayjs'
import orderBy from 'lodash-es/orderBy'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    _labels: [],
    _projects: [],
    _issues: [],
    _issuesPerDay: {},
    filter: null,
    token: null,
    host: null,
    selected_project: null,
    progress: null,
  },
  getters: {
    hasToken: ({ token }) => token && token.length > 0,
    project: ({ _projects, selected_project }) =>
      _projects.filter(x => x.id === selected_project).pop(),
    notLabeled: ({ _issues }) =>
      _issues.filter(issue => issue.labels.length === 0),
    getLabels: ({ _labels }) => _labels,
    issuesAll: ({ _issues }) => _issues,
    issuesPerDate: ({ _issuesPerDay }) => _issuesPerDay,
    showDashboard: ({ token, selected_project }) =>
      token && token.length > 0 && selected_project !== null,
    dateFrom: ({ filter }) =>
      filter && filter.from ? dayjs(filter.from) : null,
    dateTo: ({ filter }) => (filter && filter.to ? dayjs(filter.to) : null),
  },
  mutations: {
    SET_PROGRESS: (state, progress) => (state.progress = progress),
    FILTER_CHANGED: (state, { from, to }) => (state.filter = { from, to }),
    SET_TOKEN_AND_HOST: (state, { token, host }) => {
      state.host = host
      state.token = token
    },
    RESET_PROJECTS: state => (state._projects = []),
    SET_PROJECTS: (state, projects) => {
      const activeDate = dayjs().subtract(1, 'year')

      console.log(
        'Filter projects for at least a updated date from: ' +
          activeDate.toISOString()
      )

      state._projects = orderBy(
        [
          ...state._projects,
          ...projects.filter(x =>
            dayjs(x.last_activity_at).isAfter(activeDate)
          ),
        ],
        ['name_with_namespace']
      )
    },
    RESET_ISSUES: state => {
      state._issues = []
      state._issuesPerDay = {}
      state.progress = null
    },
    SET_ISSUES: (state, issues) => {
      state._issues = [
        ...state._issues,
        ...issues.map(issue => {
          issue.unix_timestamp = dayjs(issue.created_at).valueOf()
          return issue
        }),
      ]

      // create a group for each issue per day
      for (let issue of issues) {
        let day = dayjs(issue.created_at).format('YYYY-MM-DD')
        if (!state._issuesPerDay[day]) {
          state._issuesPerDay[day] = []
        }
        state._issuesPerDay[day].push(issue.id)
      }
    },
    SET_SELECTED_PROJECT: (state, selected) => {
      state.selected_project = selected
    },
    SET_LABELS: (state, _labels) =>
      (state._labels = _labels.map(label => {
        label.total_issues = label.closed_issues_count + label.open_issues_count
        return label
      })),
  },
  actions: {
    CHECKTOKEN({ commit, dispatch }, { host, token, page }) {
      const apiHost = host || 'https://gitlab.cube.nl'

      page = page || 1

      return Axios.get(`${apiHost}/api/v4/projects`, {
        params: {
          page: page,
          private_token: token,
          simple: true,
          per_page: 100,
          membership: true,
        },
      })
        .then(({ data, headers }) => {
          console.log('Token and host is set', token, apiHost)
          console.log(
            `Fetch ${data.length}/${headers['x-total']} projects from Gitlab.`
          )

          commit('SET_PROJECTS', data)

          if (
            parseInt(headers['x-total']) > 100 &&
            page !== parseInt(headers['x-total-pages'])
          ) {
            return dispatch('CHECKTOKEN', { host, token, page: page + 1 })
          }

          commit('SET_TOKEN_AND_HOST', { token, ...{ host: apiHost } })
        })
        .catch(err => {
          console.log(err)
          console.error(err)
        })
    },

    SELECT_PROJECT({ state, commit, dispatch }, { selected, page }) {
      page = page || 1

      const totalPerPage = 100

      return Axios.get(`${state.host}/api/v4/projects/${selected}/issues`, {
        params: {
          private_token: state.token,
          scope: 'all',
          order_by: 'created_at',
          per_page: totalPerPage,
          page: page,
        },
      }).then(({ data, headers }) => {
        console.log(
          `Fetch ${data.length * page}/${
            headers['x-total']
          } issues from Gitlab.`
        )
        const total = parseInt(headers['x-total'])
        const totalPages = parseInt(headers['x-total-pages'])

        commit('SET_ISSUES', data)
        commit('SET_PROGRESS', {
          total: total,
          done:
            total > totalPerPage && page !== totalPages
              ? totalPerPage * page
              : total,
          per_page: totalPerPage,
          total_pages: totalPages,
        })

        if (total > totalPerPage && page !== totalPages) {
          return dispatch('SELECT_PROJECT', { selected, page: page + 1 })
        }

        dispatch('FETCH_PROJECT_LABELS', selected)
        commit('SET_SELECTED_PROJECT', selected)
      })
    },

    FETCH_PROJECT_LABELS({ state, commit }, selected) {
      return Axios.get(`${state.host}/api/v4/projects/${selected}/labels`, {
        params: {
          private_token: state.token,
          per_page: 100,
          with_counts: true,
          include_ancestor_groups: true,
        },
      }).then(({ data }) => commit('SET_LABELS', data))
    },
  },
})
